// Text utilities — small helpers for plain-text transformations used by
// the diary module (Tiptap output → preview snippets, etc.).

/**
 * Strip HTML tags and collapse whitespace into single spaces.
 *
 * Used by the diary list cards to produce a 3-line preview from
 * Tiptap's HTML output (``diary.content``).
 *
 * @example stripHtml("<p>Hello <strong>world</strong>!</p>") === "Hello world!"
 */
export function stripHtml(input: string | null | undefined): string {
  if (!input) return "";
  return input
    .replace(/<[^>]+>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

/**
 * Extract a short preview from Tiptap HTML output.  Returns at most
 * ``maxChars`` characters; appended ellipsis when truncated.
 */
export function previewFromHtml(input: string | null | undefined, maxChars = 140): string {
  const text = stripHtml(input);
  if (text.length <= maxChars) return text;
  return text.slice(0, maxChars).trimEnd() + "…";
}
